import { SVGProps } from 'react';

const Image = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m6 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Image;
